<template>
    <div class="fullheight">
<!--        <el-page-header @back="goBack" :content="title" style="margin-bottom: 15px"></el-page-header>-->
        <!-- 图表-->
        <eip-chart :id="this.id" v-if="type==='4'"/>
        <!-- 数据报表-->
        <template-preview v-else-if="type==='2'" :templateKey="id" single="true" />
        <!-- 自定义视图-->
        <query-sql-content v-else-if="type==='3'" :sqlAlias="otherId" :alias="id" :single="true"/>
        <!-- 表单预览-->
        <preview-form v-else-if="type==='6'" :formId="id" :single="true"/>

        <iframe
                v-else-if="type==='7'"
                style="width:100%"
                frameborder="0"
                class="fullheight"
                allowtransparency="0"
                :src="path"></iframe>

        <start v-else-if="type==='8'" :defId="id" leaderId="0" :instId="''" :copeInstId="''"></start>

        <el-container style="height: 95%;" v-else-if="type==='1'">
            <el-aside>
                <el-menu
                        style="margin-top: 25px"
                        default-active="2">
                    <template v-for="menu in menus">
                        <el-submenu
                                :key="menu.id"
                                v-if="menu.children.length>0"
                                :index="menu.id">
                            <template slot="title">
                                <span>{{menu.name}}</span>
                            </template>
                            <el-menu-item
                                    :key="child.id"
                                    v-for="child in menu.children"
                                    :index="child.id"
                                    @click="open(child)">{{child.name}}</el-menu-item>
                        </el-submenu>
                        <el-menu-item
                                v-else
                                :key="menu.id"
                                :index="menu.id"
                                @click="open(menu)">{{menu.name}}</el-menu-item>
                    </template>
                </el-menu>
            </el-aside>
            <el-main :style="app.type===1?{overflowY:'hidden'}:{}">
                <!-- 图表-->
                <eip-chart :id="app.id" v-if="app.type===4"/>
                <!-- 数据报表-->
                <template-preview v-else-if="app.type===2" :templateKey="app.key"/>
                <!-- 自定义视图-->
                <query-sql-content v-else-if="app.type===3" :sqlAlias="app.sqlAlias" :alias="app.alias" single="true"/>
                <!-- 表单预览-->
                <preview-form v-else-if="app.type===6" :formId="app.id" :single="true"/>
                <!-- 网页链接-->
                <iframe
                        v-else-if="app.type===1"
                        style="width:100%;overflow-y: hidden"
                        frameborder="0"
                        class="fullheight"
                        allowtransparency="0"
                        :src="`${fvue}/${app.url}`"/>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    const eipChart = () => import("@/components/form/chart/EipChart.vue");
    const templatePreview = () => import("@/components/dataTemplate/templatePreview.vue");
    const querySqlContent = () => import("@/components/querySql/querySqlContent.vue");
    const previewForm = () => import("@/components/common/previewForm.vue");
    const start = () => import("@/components/flow/start.vue");
    import portal from "@/api/portal.js";
    import { mapState } from "vuex";
    export default {
        name: "app-content",
        components:{
            eipChart,
            templatePreview,
            querySqlContent,
            previewForm,
            start
        },
        props: {
          type: String,
          id: String,
          otherId: String
        },
        data() {
            return {
                title: "",
                iframeSrc: "",
                menus: [],
                app:{
                    id: "",
                    type: 0,
                    key: "",
                    sqlAlias: "",
                    alias: "",
                    url: ""
                },
                path: "",
                fvue: window.context.front
            }
        },
        computed: mapState({
            token: function(mapState) {
                return mapState.login.currentUser.token;
            }
        }),
        created(){
            this.init();
        },
        methods: {
            //返回
            goBack(){
                this.$router.go(-1);
            },
            //初始化标题和类型
            init(){
                if (this.type === '4'){
                    this.title = "图表";
                }else if (this.type==='2'){
                    this.title = "数据报表";
                }else if (this.type==='3'){
                    this.title = "自定义视图";
                }else if (this.type==='6'){
                    this.title = "表单";
                } else if (this.type==='7'){
                    this.title = '模块开发';
                    this.path = `${window.context.front}/sysModulePreview/${this.id}?token=${this.token}`;
                } else if (this.type==='1'){
                    this.title = "应用";
                    //获取app的菜单树
                    portal.getSysAppTree(this.id).then(data => {
                        this.menus = data;
                    })
                }else if (this.type==='8'){
                    this.title = '流程启动';
                }
            },
            //点击菜单
            open(menu){
                //菜单类型为链接菜单时不用转content内容
                if (menu.type===1){
                    this.app = {
                        url: menu.content + "?token=" +this.token,
                        type: menu.type
                    }
                    return;
                }
                //其他类型需要转换content内容
                let content = JSON.parse(menu.content);
                this.app = {
                    id: content.id,
                    type: menu.type,
                    key: content.key,
                    sqlAlias: content.sqlAlias,
                    alias: content.alias
                }
            }
        }
    }
</script>

<style scoped>

</style>
